import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

function HelpModalSlide(props) {

  const {item} = props;

  return  (
    <div className="nppe2-fc-help-modal__slide" style={{'max-height': 'calc(100vh - 50px)', 'overflow-y': 'auto'}}>
      {ReactHtmlParser(item)}
      <div className="swiper-pagination swiper-pagination-bullets"></div>
    </div>
  )
}

export default HelpModalSlide;
